(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('WikiPageTreeController', WikiPageTreeController);

    WikiPageTreeController.$inject = ['$scope', '$state', 'Wiki', 'Alerta', 'AlertService'];

    function WikiPageTreeController($scope, $state, Wiki, Alerta, AlertService) {
        var vm = this;
        vm.expanded = {};
        vm.toggleExpand = toggleExpand;
        vm.isExpanded = isExpanded;
        vm.hasChildren = hasChildren;
        vm.isActive = isActive;
        vm.openPage = openPage;
        vm.addSubpage = addSubpage;
        vm.editPage = editPage;
        vm.deletePage = deletePage;

        $scope.$watch(function () {
            return vm.pages;
        }, function (newPages) {
            if (newPages) {
                initExpanded(newPages);
            }
        }, true);

        if (vm.pages) {
            initExpanded(vm.pages);
        }

        function initExpanded(pages) {
            angular.forEach(pages, function (page) {
                vm.expanded[page.id] = true;
                if (page.filhos && page.filhos.length) {
                    initExpanded(page.filhos);
                }
            });
        }

        function hasChildren(page) {
            return page.filhos && page.filhos.length > 0;
        }

        function isExpanded(pageId) {
            return vm.expanded[pageId] !== false;
        }

        function toggleExpand(pageId, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            vm.expanded[pageId] = !isExpanded(pageId);
        }

        function isActive(pageId) {
            return vm.currentPageId && vm.currentPageId === pageId;
        }

        function openPage(pageId) {
            $state.go('detail-wiki', {spaceId: vm.spaceId, id: pageId});
        }

        function addSubpage(pageId, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            $state.go('new-wiki', {spaceId: vm.spaceId, superior: pageId});
        }

        function editPage(pageId, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            $state.go('edit-wiki', {spaceId: vm.spaceId, id: pageId});
        }

        function deletePage(page, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            Alerta.confirm('Atenção', 'Tem certeza que deseja excluir a página "' + page.titulo + '"?', 'warning', function () {
                Wiki.delete({id: page.id}, function () {
                    Alerta.success('Operação realizada', 'Página excluída.');
                    if (vm.currentPageId === page.id) {
                        $state.go('wiki-space', {spaceId: vm.spaceId});
                    }
                    if (vm.onTreeChange) {
                        vm.onTreeChange();
                    }
                }, function (error) {
                    var message = error && error.data && error.data.message
                        ? error.data.message
                        : 'Não foi possível excluir a página.';
                    AlertService.error(message);
                });
            });
        }
    }
})();
